import React from "react"
import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import TextFilter from "../filters/TextFilter"
import SortHeader from "../sorting/SortHeader"
import DateTimeFilter from "../filters/DateTimeFilter"
import { Link, useNavigate } from "react-router-dom"
import Table, { Row, Cell } from "../../ui/Table"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { selectAdvancedMode } from "../settings/slice"
import IDCopy from "../../ui/IDCopy"
import Timestamp from "../../ui/Timestamp"

const CollectionsTable = ({
  collections = [],
  filter,
  setFilter,
  stickyHeader = true,
}) => {
  // User setting to show more details such as id's
  const advancedModeState = useSelector(selectAdvancedMode)
  // if filters apply to advancedMode columns we have to show them
  const advancedModeOverride =
    filter && (filter.pipeline_id || filter.id_cnts) ? true : false
  const advancedMode = advancedModeOverride
    ? advancedModeOverride
    : advancedModeState
  const navigate = useNavigate()
  const navigateTo = (id) => () => navigate(`/collections/${id}`)

  return (
    <Table>
      <TableHeaderRow sticky={stickyHeader}>
        <TableHeader
          filterControl={
            filter && (
              <DateTimeFilter
                filter={filter}
                setFilter={setFilter}
                active={filter.from || filter.to}
              />
            )
          }
          sortControl={
            filter && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"updated"}
              />
            )
          }
        >
          Updated
        </TableHeader>
        {advancedMode && (
          <TableHeader
            filterControl={
              filter && (
                <TextFilter
                  filterByName="id_cnts"
                  filter={filter}
                  setFilter={setFilter}
                  active={filter.id}
                />
              )
            }
            sortControl={
              filter && (
                <SortHeader
                  setFilter={setFilter}
                  filter={filter}
                  sortBy={"id"}
                />
              )
            }
          >
            ID
          </TableHeader>
        )}
        <TableHeader
          filterControl={
            filter && (
              <TextFilter
                filterByName="name_cnts"
                filter={filter}
                setFilter={setFilter}
                active={filter.name_cnts}
              />
            )
          }
          sortControl={
            filter && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"name"}
              />
            )
          }
        >
          Name
        </TableHeader>
        <TableHeader>Observations</TableHeader>
        <TableHeader>Created by</TableHeader>
        {/*Actions*/}
        <TableHeader />
      </TableHeaderRow>
      {collections && (
        <tbody>
          {collections.map((collection) => (
            <Row key={collection.id} zebra>
              <Cell onClick={navigateTo(collection.id)}>
                <Timestamp utc={advancedMode} columnMode={true}>
                  {collection.updated}
                </Timestamp>
              </Cell>
              {advancedMode && (
                <Cell onClick={navigateTo(collection.id)}>
                  <IDCopy truncateTo={20} id={collection.id} showCopy={true} />
                </Cell>
              )}
              <Cell>{collection.name}</Cell>
              <Cell onClick={navigateTo(collection.id)}>
                {collection.recordings_count}
              </Cell>
              <Cell>{collection.created_by}</Cell>
              <Cell>
                <Link to={`/collections/${collection.id}`}>Detail</Link>
              </Cell>
            </Row>
          ))}
        </tbody>
      )}
    </Table>
  )
}

CollectionsTable.propTypes = {
  collections: PropTypes.array, // the collections to render
  filter: PropTypes.object, // If provided will be used to power the filters if not filters will not be shown
  setFilter: PropTypes.func, // If provided will be used to power the filters if not filters will not be shown
  stickyHeader: PropTypes.bool, // If true, table header is sticky
}

export default CollectionsTable
